<script lang="ts" setup>
import type { Album, EventVault } from "@/models"
import cover from "@brand-cover"
import { Icon } from "@/components/ui"

interface DrawerContextCardProps {
  eventVault?: EventVault
  album?: Album
}

defineProps<DrawerContextCardProps>()
</script>

<template>
  <div class="mb-5 flex gap-5">
    <img
      v-if="album?.coverImageUrl || eventVault?.coverImageUrl" class="aspect-square w-32 rounded-xl object-cover"
      loading="lazy" decoding="async" :src="album?.coverImageUrl ?? eventVault?.coverImageUrl"
      :alt="`${album?.id ? 'Album' : 'Event'} Cover image`"
      data-test="drawer_context_card_cover_image"
    >
    <img
      v-else :src="cover" loading="lazy" decoding="async"
      alt="default guestpix cover image" class="object-cover rounded-xl h-32 w-32 mb-4"
    >
    <div class="flex flex-col gap-2">
      <div class="flex gap-2">
        <Icon v-if="album" icon="Folder" class="text-nav-active" />
        <h3 class="text-lg font-comfortaa font-bold" data-test="drawer_context_card_title">
          {{ album?.title ?? eventVault?.title }}
        </h3>
      </div>
      <slot />
    </div>
  </div>
</template>
